'use client'

import React from 'react'

export type LegendItem = {
  key: string
  label: string
  color: string
  dashed?: boolean
}

export function ChartLegend({
  items,
  isDark,
}: {
  items: LegendItem[]
  isDark: boolean
}) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
      {items.map(({ key, label, color, dashed }) => (
        <div key={key} className="flex items-center gap-1.5">
          <svg width="18" height="10">
            <line
              x1="0"
              y1="5"
              x2="18"
              y2="5"
              stroke={color}
              strokeWidth="2"
              strokeDasharray={dashed ? '4 2' : undefined}
            />
          </svg>
          <span
            className={`font-mono text-[10px] uppercase tracking-widest ${
              'text-muted-foreground'
            }`}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  )
}
